import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { IGetJobsParams } from "../../../api/types/jobs/IGetJobsParams";
import { IJobInfo } from "../../../api/types/jobs/IJobInfo";
import { JobAction } from "../../../api/types/jobs/JobAction";
import { JobStatus } from "../../../api/types/jobs/JobStatus";

export const getTicketGridChildTemplates = createAsyncThunk<
  IJobInfo[],
  number
>("ticketGrids/getChildTemplates", async (parentId, thunkAPI) => {
  const params: IGetJobsParams = {
    action: JobAction.getJobs,
    status: JobStatus.template,
    parent_id: parentId,
  };
  const response = await endpoints.job.list(params, thunkAPI.signal);
  if (response.error) throw response.error;
  if (response.jobs) return response.jobs;
  throw new Error("Invalid response from the server.");
});
